/**
 * Grey DialogTitle look, matching the grey card headers (CardHeaderBar).
 * Overrides the theme's light-green title bar for the dialogs that opt in.
 */
const greyDialogTitleSx = {
  backgroundColor: '#e9ecf1',
  borderBottom: '1px solid #dcdcdc',
  '& .MuiTypography-h5': { color: '#1a1a1a' },
  '& .MuiTypography-body2': { color: '#5f6368' },
};

export default greyDialogTitleSx;
